<template>
  <InfoCard
    v-if="lpu.drcnt"
    :subtitle="`${numberFormatter.format(lpu.drcnt)} ${tStatic(declensionByNum(lpu.drcnt, ['врач', 'врача', 'врачей']))}`"
    icon="ui-icon-doctor"
    @click="handleClickDoctors"
  />
</template>

<script lang="ts" setup>
import type { CommonContextStore } from 'src/types/context'
import useURLStore from 'src/store/useURLStore'
import useContextStore from 'src/store/useContextStore'
import declensionByNum from 'src/utils/declensionByNum'
import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import InfoCard from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/InfoCard.vue'

const props = defineProps<{
  lpu: Lpu
}>()
const { urlLang }: CommonContextStore = useContextStore()
const { reverseFullL10N } = useURLStore()

const numberFormatter = new Intl.NumberFormat('ru-RU')
const lpuDoctorsUrl = reverseFullL10N({
  name: 'lpu_doctors',
  args: {
    language: urlLang,
    town_translit: props.lpu.town.translit,
    lpu_translit: props.lpu.translit,
  },
})

function handleClickDoctors() {
  window.location.assign(`${lpuDoctorsUrl}#tab-content`)
}
</script>
